import { collection, doc, runTransaction, serverTimestamp } from "firebase/firestore";
import { db } from "./config";

export const placeOrderWithToken = async (shopId, orderData) => {
    // Two separate counters:
    // 1. tokenCounter   → key is shopId only, resets ONLY on manual Start Day tap
    // 2. orderIdCounter → never resets (used for unique order ID forever)
    const tokenCounterRef = doc(db, "counters", shopId);
    const orderIdCounterRef = doc(db, "orderIdCounters", shopId);
    const orderRef = doc(collection(db, "orders"));

    let tokenNumber = 1;
    let orderIdSeq = 1;

    await runTransaction(db, async (transaction) => {
        const tokenSnap = await transaction.get(tokenCounterRef);
        const orderIdSnap = await transaction.get(orderIdCounterRef);

        tokenNumber = tokenSnap.exists() ? tokenSnap.data().lastToken + 1 : 1;
        orderIdSeq = orderIdSnap.exists() ? orderIdSnap.data().lastSeq + 1 : 1;

        const orderId = `${shopId}_${String(orderIdSeq).padStart(6, "0")}`;

        transaction.set(tokenCounterRef, { lastToken: tokenNumber, shopId });
        transaction.set(orderIdCounterRef, { lastSeq: orderIdSeq, shopId });

        transaction.set(orderRef, {
            ...orderData,
            orderId,
            tokenNumber,
            status: "pending",
            createdAt: serverTimestamp(),
        });
    });

    return { token: tokenNumber, docId: orderRef.id };
};